import { useState } from "react";
import { InfoWindow } from "@react-google-maps/api";
import Geocode from "react-geocode";

// Usage:
// const { handleMapClick, clickedLocation, clickedAddress, showClickedInfo, setShowClickedInfo } = useMapClickedInfoWindow();
// <GoogleMap onClick={handleMapClick}>...</GoogleMap>
// <MapClickedInfoWindow ...props />

export function useMapClickedInfoWindow() {
  const [clickedLocation, setClickedLocation] = useState(null);
  const [clickedAddress, setClickedAddress] = useState(null);
  const [showClickedInfo, setShowClickedInfo] = useState(false);

  const handleMapClick = async event => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    if (showClickedInfo) {
      setShowClickedInfo(false);
      setClickedLocation(null);
      setClickedAddress(null);
      return;
    }
    setShowClickedInfo(false);
    setClickedLocation({ lat, lng });
    setClickedAddress(null);
    try {
      const response = await Geocode.fromLatLng(lat, lng);
      if (
        response &&
        response.results &&
        response.results[0] &&
        response.results[0].formatted_address
      ) {
        setClickedAddress(response.results[0].formatted_address);
      } else {
        setClickedAddress(null);
      }
    } catch (err) {
      setClickedAddress(null);
    }
    setShowClickedInfo(true);
  };

  return {
    handleMapClick,
    clickedLocation,
    clickedAddress,
    showClickedInfo,
    setShowClickedInfo,
    setClickedLocation,
    setClickedAddress,
  };
}

export function MapClickedInfoWindow({
  clickedLocation,
  clickedAddress,
  showClickedInfo,
  setShowClickedInfo,
  setClickedLocation,
  setClickedAddress,
}) {
  if (!showClickedInfo || !clickedLocation) return null;
  return (
    <InfoWindow
      position={clickedLocation}
      onCloseClick={() => {
        setClickedLocation(null);
        setClickedAddress(null);
        setShowClickedInfo(false);
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", padding: 8 }}>
        {clickedAddress && (
          <p style={{ margin: "5px 0" }}>
            <strong>Address:</strong> {clickedAddress}
          </p>
        )}
        <p style={{ margin: "5px 0" }}>
          <strong>Lat:</strong> {clickedLocation.lat.toFixed(6)},{" "}
          <strong>Lng:</strong> {clickedLocation.lng.toFixed(6)}
        </p>
      </div>
    </InfoWindow>
  );
}
